<template>
    <div class="bg-white mt-3 progress-status-view activity-type-create col-12" :style="themeColor">
        <b-form class="form-sample" @submit.stop.prevent="nextStep">
            <b-row>
                <b-col cols="12" class="dd">
                    <label class="mb-3" for="customer_type_id"><strong>{{ $translate('country_code') }}</strong><span
                            class="red">*</span></label>
                    <b-form-select class="form-control" v-custom-validation="$selectRequired()" value-field="value" text-field="text" required
                        id="input-customer_country_code" v-model="model.country_code" :options="countries">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('select_country') }}</b-form-select-option>
                        </template>
                    </b-form-select>

                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="address1" class="mb-3"><strong>{{ $translate('address1') }}<span
                                class="red">*</span></strong></label>
                    <b-form-input id="address1" :placeholder="$translate('address')" v-custom-validation="$textRequired()" required v-model="model.address1"
                        type="text"></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="address2" class="mb-3"><strong>{{ $translate('address2') }}</strong></label>
                    <b-form-input :placeholder="$translate('address')" id="address2" v-model="model.address2"
                        type="text"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="City" class="mb-3"><strong>{{ $translate('city') }}<span
                                class="red">*</span></strong></label>
                    <b-form-input id="City" placeholder="City" v-custom-validation="$textRequired()"  required v-model="model.city" trim></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3 dd">
                    <label for="input-state" class="mb-3"><strong>{{ $translate("state") }}<span
                                class="red">*</span></strong></label>
                    <b-form-select class="form-control" id="input-state" v-custom-validation="$selectRequired()"  value-field="text" required
                        v-model="model.state_name" :options="states">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate("select_state") }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="zip-code" class="mb-3"><strong>{{ $translate('zip_code') }}</strong></label>
                    <b-form-input id="zip-code" :placeholder="$translate('zip_code')" v-custom-validation="$textRequired()" v-model="model.zip_code" trim></b-form-input>
                </b-col>
            </b-row>
            <b-col class="mt-5 text-center">
                <b-button type="submit" @click="prevStep()" class="btn btn-info btn-fw me-2 "
                    variant="primary">{{ $translate('previous') }}</b-button>
                <b-button type="submit" class="btn btn-info btn-fw me-2 "
                    variant="primary">{{ $translate('next') }}</b-button>
            </b-col>
        </b-form>

    </div>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'


export default {
    name: 'customerUsers-address',
    mixins: [permissionsMixins],
    data() {
        return {
            loading: false,
            hasErrors: false,
        }
    },
    props: ['value', 'themeColor'],
    computed: {
        countries() {
            return this.$store.state.locations.country
        },
        states() {
            return this.$store.state.locations.states
        },
        model: {
            // getter

            get() {
                console.log('...........', this.value)
                return this.value
            },
        }
    },
    created() {
        this.$store.dispatch('locations/fetchCountry')
    },
    mounted() { },
    watch: {
        'model.country_code': {
            immediate: true,
            handler: async function (val) {
                await this.$store.dispatch('locations/fetchstate', val)
            },
        },
    },
    methods: {
        nextStep() {
            this.$emit('next-clicked'); // Emit the custom event
        },
        prevStep() {
            this.$emit('prev-clicked'); // Emit the custom event
        },
        // async fetchCoordinates() {
        //     if (this.isReadOnly) return
        //     let coords = {
        //         latitude: 0,
        //         longitude: 0
        //     }
        //     try {
        //         const {
        //             country_code,
        //             city,
        //             address1, state
        //         } = this.model

        //         // console.log("this.model.......",this.model)
        //         if (!(country_code || city || address1 || state))
        //             throw new Error('Invalid Address!')

        //         coords = await this.$store.dispatch(
        //             'locations/geocodeAddress',
        //             this.model
        //         )
        //     } catch (err) {
        //         //console.log('fetchCoordinates error', err)
        //     } finally {
        //         for (const key in coords) {
        //             this.$set(this.model, key, coords[key])
        //         }
        //         this.$emit('update-location-model', {
        //             ...this.model
        //         })
        //     }
        // },
    },
}
</script>
<style></style>
